// @flow
import {
  HomePage,
  Dashboard,
  ReDashboard,
  HoldingPage,
  HoldingsDCIO,
  AttributionPage,
  CashAndOnaPage,
  TransactionPage,
  About,
  AboutChild,
  RoutesDemo,
  Address,
  BasicDetails,
  Confirmation,
  Declaration,
  Registration,
  Login,
  Logout,
  ForgotPassword,
  Reporting,
  ChangePassword,
  SchemeSelection,
  TitleAndTerms,
  UserPreReg,
  ManageUsers,
  FundPerformance,
  ClientPerformance,
  SubscriptionRedemption,
  LegalInformation,
  PrivacyPolicy,
  TermsAndConditions,
  TermsAndConditionsCa,
  FAQ,
  PersonalDetails,
  AddEditUser,
  ResetPassword,
  SessionTimeOutModal,
  HelpAndSupport,
  EmailVerification,
  Adhocfaq,
  UnregisterUserList,
  FundDashboard,
  FundPrice,
  PasswordPolicy,
  HandlerError,
  AlertSubscription
} from './lazyRoutesComponent';

const routeConfig = {
  redirectIfNotFound: true, // Redirect if route is not found. Depending on secure mode, it will redirect to default unsecure or secure route.
  secureDefaultRoute: '/', // Default secure route.
  unsecureDefaultRoute: '/', // Default unsecure route.
  routes: [
    {
      path: '/',
      component: Login,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/logout',
      component: Logout,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/forgotpassword',
      component: ForgotPassword,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/resetpassword',
      component: ResetPassword,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/legal',
      component: LegalInformation,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/adhocfaq',
      component: Adhocfaq,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/faq',
      component: FAQ,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/personalDetails',
      component: PersonalDetails,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/helpsupport',
      component: HelpAndSupport,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/addUser',
      component: AddEditUser,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/editUser',
      component: AddEditUser,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/privacy',
      component: PrivacyPolicy,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/terms',
      component: TermsAndConditions,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/termsca',
      component: TermsAndConditionsCa,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/HomePage',
      component: HomePage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/holdings',
      component: HoldingPage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/holdingsFund',
      component: HoldingPage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/holdingsDCIO',
      component: HoldingsDCIO,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/attribution',
      component: AttributionPage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/transaction',
      component: TransactionPage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/transactionDCIO',
      component: TransactionPage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/subscriptionsRedemptions',
      component: SubscriptionRedemption,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/cashandona',
      component: CashAndOnaPage,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/manageusers',
      component: ManageUsers,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/factsheets',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/LifeCoBooklet',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/PS',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/MAR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/MIR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/GCR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/QAR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/QIR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/PVR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/SFD',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/complianceCertificate',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/tradeConfirmation',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/SDL',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/BTS',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/AFS',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/FFS',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/QIS',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/DCPT_FVPT',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/Business',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/SFDR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/Corporate',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/Policy',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/QIR',
      component: Reporting,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/Dashboard',
      component: Dashboard,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/FundDashboard',
      component: FundDashboard,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/redashboard',
      component: ReDashboard,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/DashboardDCIO',
      component: Dashboard,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/DashboardSeg',
      component: Dashboard,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/fundPerformance',
      component: FundPerformance,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/fundPerformancef',
      component: FundPerformance,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/fundPrice',
      component: FundPrice,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/clientPerformance',
      component: ClientPerformance,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/about',
      component: About,
      exact: true,
      type: 'NON_AUTH_ROUTE',
      routeData: {
        componentData: [
          {
            key: 'initialData',
            accessor: 'routesDemo.routes.basic',
          },
        ],
      },
    },
    {
      path: '/about/:id',
      component: AboutChild,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/router-demo',
      component: RoutesDemo,
      type: 'NON_AUTH_ROUTE',
      routes: [
        {
          path: '/router-demo/register',
          component: Registration,
        },
        {
          path: '/router-demo/address',
          component: Address,
          type: 'NON_AUTH_ROUTE',
        },
        {
          path: '/router-demo/basic',
          component: BasicDetails,
          type: 'NON_AUTH_ROUTE',
          routeData: {
            componentData: [
              {
                key: 'initialData',
                accessor: 'routesDemo.routes.basic',
              },
            ],
          },
        },
        {
          path: '/router-demo/confirmation',
          component: Confirmation,
          type: 'NON_AUTH_ROUTE',
          routes: [
            {
              path: '/router-demo/confirmation/:id',
              component: AboutChild,
              type: 'NON_AUTH_ROUTE',
              routeData: {
                componentData: [
                  {
                    key: 'initialData',
                    accessor: 'routesDemo.routes.basic',
                  },
                ],
              },
            },
          ],
        },
        {
          path: '/router-demo/declaration',
          component: Declaration,
          type: 'NON_AUTH_ROUTE',
        },
      ],
    },
    {
      path: '/login',
      component: Login,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/changepassword',
      component: ChangePassword,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/schemeselection',
      component: SchemeSelection,
      exact: true,
    },
    {
      path: '/titleandterms',
      component: TitleAndTerms,
      exact: true,
    },
    {
      path: '/handlerError',
      component: HandlerError,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/userprereg',
      component: UserPreReg,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/sessiontimeout',
      component: SessionTimeOutModal,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/verifyemail',
      component: EmailVerification,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/ca',
      component: Login,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/unregisteruserlist',
      component: UnregisterUserList,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/passwordpolicy',
      component: PasswordPolicy,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    },
    {
      path: '/alertsubscription',
      component: AlertSubscription,
      exact: true,
      type: 'NON_AUTH_ROUTE',
    }
  ],
};

export default routeConfig;
